module.exports = __webpack_public_path__ + "img/metro.4e28a52c.png";